import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import content from './notes/index.js';


export default function Sidebar(props) {
    const [expandedFolder, setExpandedFolder] = React.useState('');

    const folderClickHandler = (e) => {
        if (expandedFolder === e.name) {
            setExpandedFolder('');
        }
        else {
            setExpandedFolder(e.name);
        }
    }

    const location = useLocation();

    let expand_tree = (e, base_path) => {
        if (e.folder) {
            return (
                <SidebarFolder key={e.name} text={e.name} expanded={expandedFolder === e.name} clickHandler={() => folderClickHandler(e)}>
                    <div className="pl-6">
                        {e.items.map((item) => expand_tree(item, base_path + e.path + '/'))}
                    </div>
                </SidebarFolder >
            );
        }
        else {
            const path = base_path + e.path;
            const selected = location.pathname === path;
            return <SidebarItem key={e.name} text={e.name} selected={selected} path={path} />
        }
    }


    return (
        <div className="sticky top-0 flex-initial w-32 h-screen bg-gray-100 lg:w-64">
            <span className="flex items-center justify-center h-12 pt-3 text-lg tracking-wide text-purple-700 bg-gray-100 border-b-2 border-gray-300">Notes</span>

            {/* <Search /> */}

            <nav className="mt-10">
                {content.map((item) => expand_tree(item, '/notes/'))}
            </nav>

            {/* <div className="absolute bottom-0 my-10">
                <a className="flex items-center px-8 py-2 text-gray-500 hover:text-gray-600" href="#">
                    <span className="mx-4 font-medium">Support</span>
                </a>
            </div> */}
        </div >
    );
}

function Search(props) {
    return (
        <div className="relative pt-2 mx-auto mt-2 text-gray-600">
            <input className="w-full h-10 px-5 leading-tight bg-white border-2 border-gray-300 rounded-lg focus:outline-none"
                type="search" name="search" placeholder="Search" />
            <button type="submit" className="absolute top-0 right-0 mt-5 mr-4">
                <svg className="w-4 h-4 text-gray-600 fill-current" xmlns="http://www.w3.org/2000/svg"
                    xmlns-xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px"
                    viewBox="0 0 56.966 56.966" xml-space="preserve"
                    width="512px" height="512px">
                    <path
                        d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z" />
                </svg>
            </button>
        </div>
    );
}

function SidebarFolder(props) {

    const default_classes = "flex items-center w-full px-2 py-3 border-r-4  outline-none focus:outline-none";
    const selected_classes = "text-gray-700 bg-gray-200 border-purple-700";
    const unselected_classes = "text-gray-600 border-white hover:bg-gray-200 hover:text-gray-700";
    const classes = default_classes + ' ' + (props.selected ? selected_classes : unselected_classes);

    const sub_menu = props.expanded ? props.children : <></>;

    return (
        <div>
            <button className={classes} onClick={props.clickHandler}>
                {/* <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 11H5M19 11C20.1046 11 21 11.8954 21 13V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V13C3 11.8954 3.89543 11 5 11M19 11V9C19 7.89543 18.1046 7 17 7M5 11V9C5 7.89543 5.89543 7 7 7M7 7V5C7 3.89543 7.89543 3 9 3H15C16.1046 3 17 3.89543 17 5V7M7 7H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg> */}

                <span className="mx-2 font-medium">{props.text}</span >
            </button >
            {sub_menu}
        </div>
    );
}

function SidebarItem(props) {

    const default_classes = "flex items-center w-full px-2 py-1 outline-none focus:outline-none";
    const selected_classes = "text-purple-700";
    const unselected_classes = "text-gray-800 hover:underline";
    const classes = default_classes + ' ' + (props.selected ? selected_classes : unselected_classes);

    return (
        <Link className={classes} to={props.path} >
            {/* <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 11H5M19 11C20.1046 11 21 11.8954 21 13V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V13C3 11.8954 3.89543 11 5 11M19 11V9C19 7.89543 18.1046 7 17 7M5 11V9C5 7.89543 5.89543 7 7 7M7 7V5C7 3.89543 7.89543 3 9 3H15C16.1046 3 17 3.89543 17 5V7M7 7H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg> */}

            <span className="mx-2">{props.text}</span >
        </Link>

    );
}
